<template>
  <div class="container py-5 shadow-lg rounded" style="max-width: 50%">
    <h2 class="mb-4 card-title text-center">Cálculo de Mediación</h2>
    <div class="row">
      <div class="col-3">
        <div class="row input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">Cuantía:</span>
          </div>
          <input
            type="number"
            class="mt-3 form-control"
            v-model.number="cuantia"
            placeholder="Introduce la cuantía"
            @input="validateInput"
          />
        </div>
      </div>
      <div class="col">
        <div class="row card-body mx-3">
          <table class="table responsive table-hover text-left">
            <tbody>
              <tr v-if="rangoActual">
                <td>Fracción Básica:</td>
                <td>
                  <i class="fas fa-dollar-sign"></i>${{
                    rangoActual.fraccionBasica
                  }}
                </td>
              </tr>
              <tr v-if="rangoActual">
                <td>Por cada Mil en Exceso:</td>
                <td>${{ rangoActual.porMilExceso }}</td>
              </tr>
              <tr v-if="rangoActual">
                <td>Costo por cada mil exceso:</td>
                <td>${{ calculo.milxexceso }}</td>
              </tr>
              <tr v-if="rangoActual">
                <td>Subtotal:</td>
                <td>${{ calculo.calc }}</td>
              </tr>
              <tr v-if="rangoActual">
                <td>15% IVA:</td>
                <td>${{ calculo.iva }}</td>
              </tr>
              <tr v-if="rangoActual">
                <td><strong>Total Costo Acta Mediación:</strong></td>
                <td>
                  <strong>${{ calculo.total }}</strong>
                </td>
              </tr>
              <tr v-else>
                <td colspan="2">
                  <strong>La cuantía no está dentro de ningún rango.</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalculoMediacion",
  props: {
    msg: String,
  },
  data() {
    return {
      cuantia: null,

      rangos: [
        {
          desde: 0.01,
          hasta: 499,
          fraccionBasica: 40,
          porMilExceso: 0,
        },
        {
          desde: 500.0,
          hasta: 999,
          fraccionBasica: 40,
          porMilExceso: 20,
        },
        {
          desde: 1000.0,
          hasta: 1999.0,
          fraccionBasica: 48.0,
          porMilExceso: 18.0,
        },
        {
          desde: 2000.0,
          hasta: 3999.0,
          fraccionBasica: 68.0,
          porMilExceso: 16.0,
        },
        {
          desde: 4000.0,
          hasta: 7999.0,
          fraccionBasica: 91.0,
          porMilExceso: 15.0,
        },
        {
          desde: 8000.0,
          hasta: 15999.0,
          fraccionBasica: 150.0,
          porMilExceso: 13.0,
        },
        {
          desde: 16000.0,
          hasta: 31999.0,
          fraccionBasica: 252.0,
          porMilExceso: 11.0,
        },
        {
          desde: 32000.0,
          hasta: 63999.0,
          fraccionBasica: 440.0,
          porMilExceso: 9.0,
        },
        {
          desde: 64000.0,
          hasta: 127999.0,
          fraccionBasica: 827.0,
          porMilExceso: 8.0,
        },
        {
          desde: 128000.0,
          hasta: 255999.0,
          fraccionBasica: 1390.0,
          porMilExceso: 7.0,
        },
        {
          desde: 256000.0,
          hasta: 511999.0,
          fraccionBasica: 2650.0,
          porMilExceso: 6.0,
        },
        {
          desde: 512000.0,
          hasta: 1023999.0,
          fraccionBasica: 4950.0,
          porMilExceso: 5.0,
        },
        {
          desde: 1024000.0,
          hasta: 2047999.0,
          fraccionBasica: 8500.0,
          porMilExceso: 4.0,
        },
        {
          desde: 2048000.0,
          hasta: 4095999.0,
          fraccionBasica: 15700.0,
          porMilExceso: 3.0,
        },
        {
          desde: 4096000.0,
          hasta: Infinity,
          fraccionBasica: 28200.0,
          porMilExceso: 2.0,
        },
      ],
    };
  },

  computed: {
    calculo() {
      if (this.rangoActual) {
        let milxexceso =
          ((this.cuantia - this.rangoActual.desde) / 1000) *
          this.rangoActual.porMilExceso;
        let calc = this.rangoActual.fraccionBasica + milxexceso;
        let iva = calc * 0.15;
        let total = calc + iva;
        return {
          calc: calc.toFixed(2),
          iva: iva.toFixed(2),
          total: total.toFixed(2),
          milxexceso: milxexceso.toFixed(2),
        };
      }
      return { calc: 0, milxexceso: 0, iva: 0, total: 0 };
    },

    rangoActual() {
      return this.rangos.find(
        (rango) => this.cuantia >= rango.desde && this.cuantia <= rango.hasta
      );
    },
  },
  methods: {
    validateInput() {
      if (
        this.cuantia !== null &&
        this.cuantia !== undefined &&
        this.cuantia !== ""
      ) {
        let cuantiaNumber = Number(this.cuantia);
        if (cuantiaNumber > 999999999999.99) {
          this.cuantia = 999999999999.99;
        } else if (cuantiaNumber < 0) {
          this.cuantia = 0;
        } else {
          this.cuantia = parseFloat(cuantiaNumber.toFixed(2));
        }
      }
    },
  },
  watch: {
    cuantia: function () {
      this.validateInput();
    },
  },
};
</script>

<style scoped>
.container {
  background-color: #f8f9fa;
  border-radius: 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.input-group {
  margin: 0 20px;
}

.input-group-text {
  background-color: #e9ecef;
  transition: background-color 0.3s ease;
}

.input-group-text:hover {
  background-color: #d7dde4;
}

.table {
  background-color: #e9ecef;
  border-radius: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

tr {
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.3s ease;
}

tr:hover {
  background-color: #d7dde4;
}

td {
  padding: 10px;
  transition: background-color 0.3s ease;
}

td:hover {
  background-color: #c4ccd4;
}
</style>
